import { DrEntity } from './dr-entity';
import { DrObject, DrObjectType } from './dr-object';
import * as _ from 'underscore';

export enum RepresentationSet {
    NO_INDEX = 'NO_INDEX',
    METADATA_INDEX = 'METADATA_INDEX',
    CONTENT_INDEX = 'CONTENT_INDEX',
    VECTOR_SET = 'VECTOR_SET',
    SYSTEM_METADATA_INDEX = 'SYSTEM_METADATA_INDEX',
    TEXT_SET = 'TEXT_SET'
}
export enum SharedState {
    PRIVATE = 'PRIVATE',
    SHARED = 'SHARED'
}
export enum SmfType {
    Cellebrite = 'CELLEBRITE',
    Slack = 'SLACK'
}

export class CorpusViewModel extends DrObject {
    model: Partial<Corpus>;
    constructor(value?: Partial<Corpus>) {
        super(DrObjectType.CORPORA);
        if (value) {
            this.model = value;
        }
    }
}

export class Corpus extends DrEntity {
    name: string;
    description: string;
    corpusViewHandle: string;
    representationSet: Array<RepresentationSet>;
    documentCount: number;
    lastUpdateTimestamp: string;
    busy: boolean;
    dataAreaSet: Array<any>;
    corpusVersion: number;
    deletePending: boolean;
    sourceDataInDocStorage: boolean;
    owner: string;
    sharedState: SharedState;
    batchName: string;
    inCaseData: boolean;
    tokenizerConfigScheme: number;
    loadFileDataSet: boolean;
    archived: boolean;

    // off-model display values
    representationType: RepresentationSet;
    representationTypeDisplay: string;
    connectorName: string;
    dataAreaPaths: string;
    sharedStateDisplay: string;
    tokenizerConfigSchemeDisplay: string;
    ownerDescription: string;
    attachedProjects: Array<{ name: string, description: string }>;    
    smf: boolean;

    constructor(value?: Partial<Corpus>) {
        super(value);
        if (value) {
            Object.assign(this, value);

            this.representationType = RepresentationSet.NO_INDEX;
            this.representationTypeDisplay = 'Do Not Index';
            if (this.representationSet && this.representationSet.length > 0) {
                if (this.representationSet.includes(RepresentationSet.VECTOR_SET)) {
                    this.representationType = RepresentationSet.VECTOR_SET;
                    this.representationTypeDisplay = 'Analytic Index';
                } else if (this.representationSet.includes(RepresentationSet.CONTENT_INDEX)) {
                    this.representationType = RepresentationSet.CONTENT_INDEX;
                    this.representationTypeDisplay = 'Content Index';
                } else if (this.representationSet.includes(RepresentationSet.METADATA_INDEX)) {
                    this.representationType = RepresentationSet.METADATA_INDEX;
                    this.representationTypeDisplay = 'File Metadata';
                } else if (this.representationSet.includes(RepresentationSet.SYSTEM_METADATA_INDEX)) {
                    this.representationType = RepresentationSet.SYSTEM_METADATA_INDEX;
                    this.representationTypeDisplay = 'System Metadata';
                }
            }
            if (this.busy) {
                this.representationTypeDisplay = 'In Progress';
            }

            if (this.dataAreaSet && this.dataAreaSet.length > 0) {
                this.connectorName = this.dataAreaSet[0].connectorName;
                this.dataAreaPaths = this.dataAreaSet.map(x => x.path).join(', ');
            }

            if (this.sharedState) {
                switch (this.sharedState) {
                    case SharedState.PRIVATE: this.sharedStateDisplay = 'Private'; break;
                    case SharedState.SHARED: this.sharedStateDisplay = 'Shared'; break;
                }
            }
            this.tokenizerConfigSchemeDisplay = this.tokenizerConfigScheme === 1 ? 'V1' : 'V2';

            this.smf = false;
            if (this.attributes?.length > 0) {
                const smfAttr = _.find(this.attributes, entry => entry.name === 'shortMessageFormat');
                if (smfAttr) {
                    this.smf = smfAttr.value;
                }
            }
        }
    }
}
